var Backbone, EmailFormTextParagraphView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormTextParagraphView = (function(superClass) {
  extend(EmailFormTextParagraphView, superClass);

  function EmailFormTextParagraphView() {
    return EmailFormTextParagraphView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextParagraphView.prototype.tagName = 'li';

  EmailFormTextParagraphView.prototype.initialize = function(options) {
    this.options = options || {};
    this.model = this.options.model;
    this.label = this.model.label;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.base_template = this.options.template;
    this.template = {
      text_paragraph_template: true
    };
    return this.isInputCompulsory = this.model.required === true || this.model.required === "true";
  };

  EmailFormTextParagraphView.prototype.render = function() {
    return this.$el.html(toHtml(this.base_template, this.toHash()));
  };

  EmailFormTextParagraphView.prototype.toHash = function() {
    var hash, labels, textLines;
    labels = this.label.split('\\n');
    textLines = [];
    _.each(labels, function(label, index) {
      textLines[index] = {};
      return textLines[index].text = label;
    });
    hash = {
      required: this.isInputCompulsory,
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      counter: this.model.counter,
      labels: textLines
    };
    return _.extend(this.template, hash);
  };

  EmailFormTextParagraphView.prototype.isInputGiven = function() {
    return true;
  };

  EmailFormTextParagraphView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormTextParagraphView.prototype.populateInput = function(data) {
    return data;
  };

  EmailFormTextParagraphView.prototype.validateEmailForm = function() {
    return this.options.validateEmailForm();
  };

  return EmailFormTextParagraphView;

})(Backbone.View);

module.exports = EmailFormTextParagraphView;

//# sourceMappingURL=data:application/json;base64,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
